<template>
	<Picker v-if="color" :value="color"
			:class="$css(styles.picker)"
			@input="onChange" v-on-clickaway="onAway"/>
</template>

<script>
	import {Chrome as Picker} from "vue-color";
	import { mixin as clickaway } from "vue-clickaway";

	function styles(){
		return this.$style({
			picker: {...this.position},
		});
	}

	const getThrottledColorChanger = () => {
		let toId = null;

		function throttled(value){ //cant use arrow function, need access to 'this'
			this.lastValue = value;

			if (!toId) {
				toId = setTimeout(() => { //emit change every 1/5 a second instead of constantly
					this.$emit("change", this.lastValue.hex);
					clearTimeout(toId);
					toId = null;
				}, 200);
			}
		}

		return throttled;
	};

	export default {
		name: "ColorPicker",
		mixins: [ clickaway ],

		props: {
			color: String,
			position: Object,
		},

		data() {
			return {
				lastValue: null,
			};
		},

		computed:{
			styles,
		},

		components: {
			Picker,
		},

		methods: {
			onChange: getThrottledColorChanger(),

			onAway(){
				this.$emit("clickedAway", this.lastValue ? this.lastValue.hex : this.color);
			},
		},
	}
</script>

<style lang="scss">
	.vc-chrome {
		position: absolute;
	}
</style>
